import axios, {AxiosError, AxiosResponse} from 'axios';
import {WebinarObject} from './types';
import {ErrorObject} from 'types';
import queryString from 'query-string';

export interface GetWebinarsParams {
  title?: string;
  skip?: number;
  limit?: number;
  my?: string;
}

/**
 * The request get all webinars.
 * @param {GetWebinarsParams} params
 * @return {Promise<WebinarObject | ErrorObject>}
 */
export async function getWebinars(params?: GetWebinarsParams) {
  return axios({
    method: 'GET',
    url: queryString.stringifyUrl({
      url: `${process.env.REACT_APP_API_BASE_URL}/webinars`,
      query: params && {
        ...params,
      },
    }),
  }).then((response: AxiosResponse<WebinarObject[]>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * The request get webinar by id.
 * @param {WebinarObject<id>} id
 * @return {Promise<WebinarObject | ErrorObject>}
 */
export async function getWebinarByID(id: WebinarObject['id']) {
  return axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_BASE_URL}/webinars/${id}`,
  }).then((response: AxiosResponse<WebinarObject>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * The request create webinar.
 * @param {Omit<WebinarObject, 'id'>} webinar
 * @return {Promise<WebinarObject | ErrorObject>}
 */
export async function createWebinar(webinar: Omit<WebinarObject, 'id'>) {
  return axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_BASE_URL}/webinars`,
    data: JSON.stringify({
      ...webinar,
      time: 0,
      content: [],
    }),
  }).then((response: AxiosResponse<WebinarObject>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * The request edit the webinar.
 * @param {WebinarObject} webinar
 * @return {Promise<WebinarObject | ErrorObject>}
 */
export async function editWebinar(webinar: WebinarObject) {
  return axios({
    method: 'PATCH',
    url: `${process.env.REACT_APP_API_BASE_URL}/webinars`,
    data: JSON.stringify(webinar),
  }).then((response: AxiosResponse<WebinarObject>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}
